function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 0H2.5C1.125 0 0 1.125 0 2.5V12.5C0 13.875 1.125 15 2.5 15H12.5C13.875 15 15 13.875 15 12.5V2.5C15 1.125 13.875 0 12.5 0ZM12.5 6.5625L10.1875 8.625L10.875 11.6875C10.9375 11.9375 10.875 12.125 10.6875 12.3125C10.625 12.375 10.5 12.4375 10.375 12.4375C10.25 12.4375 10.1875 12.4375 10.0625 12.375L7.5 10.6875L4.9375 12.25C4.75 12.375 4.5 12.375 4.3125 12.25C4.125 12.125 4.0625 11.875 4.125 11.625L4.8125 8.625L2.5 6.5625C2.3125 6.375 2.25 6.1875 2.3125 5.9375C2.375 5.75 2.5625 5.5625 2.8125 5.5625L5.8125 5.25L7 2.375C7.0625 2.25 7.1875 2.125 7.3125 2.0625C7.56248 1.9375 7.93748 2.0625 8.00002 2.375L9.1875 5.25L12.1875 5.5C12.4375 5.5 12.625 5.6875 12.6875 5.875C12.75 6.125 12.6875 6.375 12.5 6.5625Z",
  fill: "#0D8F0A"
});

var SvgRating = function SvgRating(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRating, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Rating.ea8f84f7.svg";
export { ForwardRef as ReactComponent };